import { useQuery } from "@tanstack/react-query";
import estimateProvider from "@/providers/estimate.provider";
import { ESTIMATE_KEYS } from "./queryKeys";

export function useEstimationQuery(estimateId: string | undefined) {
  return useQuery({
    queryKey: ESTIMATE_KEYS.detailMetadata(estimateId ?? ""),
    queryFn: async () => {
      if (!estimateId) {
        throw new Error("estimateId is required");
      }
      const estimates = await estimateProvider.getEstimates(estimateId);
      return estimates?.[0] ?? null;
    },
    enabled: !!estimateId,
  });
}
